import { render, staticRenderFns } from "./GoldWatch.vue?vue&type=template&id=4c43295c&scoped=true"
import script from "./GoldWatch.vue?vue&type=script&lang=js"
export * from "./GoldWatch.vue?vue&type=script&lang=js"
import style0 from "./GoldWatch.vue?vue&type=style&index=0&id=4c43295c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c43295c",
  null
  
)

export default component.exports